//
//
//
//
//
//
//
//
//

import adaptiveElement from '~/mixins/adaptiveElement'

export default {
  name: 'AbsoluteElement',
  mixins: [adaptiveElement],
  data () {
    return {
      input: {
        id: null
      },
      list_: {
        state: true,
        show: true,
        prevChoice: null,
        curId: 0,
        value: '',
        valuePrev: '',
        loading: false,
        list: undefined,
        style: {}
      }
    }
  },
  methods: {
    show () {
      this.setAbsolute()
    },
    hide () {
      this.closeAdaptivePosition()
      this.list_.show = false
    },
    setAbsolute () {
      this.getAdaptivePosition({
        ctx: this,
        callback: this.setListStyle,
        el: this.$refs.list,
        fixed: true,
        parEl: this.$el,
        realParEl: this.$el
      })
    },
    setListStyle (params) {
      this.list_.style = {
        ...params
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * 100000)
    }
  },
  beforeDestroy () {
    this.hide()
  }
}

